var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKebabIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64062 4.92188C0.738281 4.92188 0 5.66016 0 6.5625C0 7.46484 0.738281 8.20312 1.64062 8.20312C2.54297 8.20312 3.28125 7.46484 3.28125 6.5625C3.28125 5.66016 2.54297 4.92188 1.64062 4.92188ZM1.64062 0C0.738281 0 0 0.738281 0 1.64062C0 2.54297 0.738281 3.28125 1.64062 3.28125C2.54297 3.28125 3.28125 2.54297 3.28125 1.64062C3.28125 0.738281 2.54297 0 1.64062 0ZM1.64062 9.84375C0.738281 9.84375 0 10.582 0 11.4844C0 12.3867 0.738281 13.125 1.64062 13.125C2.54297 13.125 3.28125 12.3867 3.28125 11.4844C3.28125 10.582 2.54297 9.84375 1.64062 9.84375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabIcon);
export default __webpack_public_path__ + "static/media/kebab-icon.5723bae5.svg";
export { ForwardRef as ReactComponent };